import { render, staticRenderFns } from "./FixSaleActionsModal.vue?vue&type=template&id=41addef0&scoped=true&"
import script from "./FixSaleActionsModal.vue?vue&type=script&lang=ts&"
export * from "./FixSaleActionsModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41addef0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41addef0')) {
      api.createRecord('41addef0', component.options)
    } else {
      api.reload('41addef0', component.options)
    }
    module.hot.accept("./FixSaleActionsModal.vue?vue&type=template&id=41addef0&scoped=true&", function () {
      api.rerender('41addef0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dossier/FixSaleActionsModal.vue"
export default component.exports